import { render, staticRenderFns } from "./PartDetailUpload.vue?vue&type=template&id=404d8075&"
import script from "./PartDetailUpload.vue?vue&type=script&lang=js&"
export * from "./PartDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports